/**
 * PENDENTE/LIBERADO no batch (view=card) podem ser só IDs.
 * Resolve a partir dos grupos de status; objeto full permanece como fallback.
 */

const MAIN_BOARD_SECTIONS = [
  'Em deslocamento',
  'Em serviço',
  'Previsto para hoje',
  'Previstas para amanhã',
  'FUTURA',
];

const CONDT_AUX_SECTIONS = ['PENDENTE', 'LIBERADO'];

export function extractBoardOrderId(item) {
  if (item == null) return null;
  if (typeof item === 'string' || typeof item === 'number') {
    const s = String(item).trim();
    return s || null;
  }
  if (typeof item === 'object') {
    const raw = item.id ?? item.TB02115_CODIGO;
    if (raw == null || raw === '') return null;
    return String(raw);
  }
  return null;
}

/** Ref enxuta (id) vs OS já hidratada (tem campos de card/listagem). */
export function isCondtAuxIdRef(item) {
  if (typeof item === 'string' || typeof item === 'number') return true;
  if (!item || typeof item !== 'object') return false;
  if (item.cliente != null || item.sla != null || item.tipo != null || item.cidade != null) {
    return false;
  }
  return extractBoardOrderId(item) != null;
}

function buildOrdersIndexFromMainGroups(techData) {
  const byId = new Map();
  if (!techData || typeof techData !== 'object') return byId;
  for (const section of MAIN_BOARD_SECTIONS) {
    const list = techData[section];
    if (!Array.isArray(list)) continue;
    for (const order of list) {
      const id = extractBoardOrderId(order);
      if (!id || byId.has(id)) continue;
      if (order && typeof order === 'object') byId.set(id, order);
    }
  }
  return byId;
}

/**
 * Expande PENDENTE/LIBERADO (ids ou objetos) para objetos full a partir dos grupos.
 * Não muta o original.
 */
export function hydrateTechnicianCondtAuxGroups(techData) {
  if (!techData || typeof techData !== 'object') return techData;
  const index = buildOrdersIndexFromMainGroups(techData);
  let changed = false;
  const next = { ...techData };

  for (const section of CONDT_AUX_SECTIONS) {
    const list = techData[section];
    if (!Array.isArray(list) || list.length === 0) continue;
    const resolved = [];
    for (const item of list) {
      const id = extractBoardOrderId(item);
      if (!id) continue;
      if (isCondtAuxIdRef(item)) {
        const full = index.get(id);
        if (full) {
          resolved.push(full);
          changed = true;
        }
        // ID sem OS nos grupos: ignora (não inventa stub)
        continue;
      }
      // Já é objeto full (órfão ou API antiga) — mantém
      resolved.push(item);
    }
    if (resolved !== list) {
      next[section] = resolved;
      if (resolved.length !== list.length || resolved.some((o, i) => o !== list[i])) {
        changed = true;
      }
    }
  }

  return changed ? next : techData;
}

export function hydrateTechnicianGroupsCondtAux(groupsByTechName) {
  if (!groupsByTechName || typeof groupsByTechName !== 'object') return groupsByTechName;
  let changed = false;
  const next = {};
  for (const [name, data] of Object.entries(groupsByTechName)) {
    const hydrated = hydrateTechnicianCondtAuxGroups(data);
    next[name] = hydrated;
    if (hydrated !== data) changed = true;
  }
  return changed ? next : groupsByTechName;
}
